import React from 'react';
import Button from '../button';
import './styles.scss';

export default function ConfirmModal({ title = 'Confirm', message = 'Are you sure?', onConfirm, onCancel }) {
  return (
    <div className="confirm-overlay">
      <div className="confirm-card">
        <div className="confirm-header">
          <h3>{title}</h3>
        </div>
        <div className="confirm-body">
          <p>{message}</p>
        </div>
        <div className="confirm-actions">
          <Button appearance="subtle" onClick={onCancel}>Cancel</Button>
          <Button appearance="danger" onClick={onConfirm}>Confirm</Button>
        </div>
      </div>
    </div>
  );
}
